import { render, staticRenderFns } from "./MypageOneTimePassCompletePage.vue?vue&type=template&id=ed8e92be"
import script from "./MypageOneTimePassCompletePage.vue?vue&type=script&lang=ts"
export * from "./MypageOneTimePassCompletePage.vue?vue&type=script&lang=ts"
import style0 from "./MypageOneTimePassCompletePage.vue?vue&type=style&index=0&id=ed8e92be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports